// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_GO_TO_CHARTS = "\u017deb\u0159\u00ed\u010dky";
export const STROLLERS_HOME_ALL_BRANDS = "V\u0161echny zna\u010dky ko\u010d\u00e1rk\u016f";
export const STROLLERS_HOME_BRANDS_count = ["%(count)s zna\u010dka", "%(count)s zna\u010dky", "%(count)s zna\u010dek"];
export const STROLLERS_HOME_POPULAR_BRANDS = "Popul\u00e1rn\u00ed zna\u010dky";
